import styled, { keyframes } from "styled-components"
import themeGet from "@styled-system/theme-get"

export const CardWrapper = styled.div`
  overflow: hidden;
  height: 500px;
  width: 400px;
  margin: 0.5rem 0 1rem 0;
  background-color: #fff;
  transition: box-shadow 0.25s;
  border-radius: 2px;

  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
    0 3px 1px -2px rgba(0, 0, 0, 0.2);
  img {
    width: 100%;
    object-fit: contain;
    margin: 0;
  }

  i {
    float: right;
  }
`

export const MainCardContent = styled.div`
  overflow: hidden;
  transition: max-height 0.5s ease-out, opacity 0.25s ease-out;
  height: 500px;
  max-height: ${props => (props.isOpen ? "0px" : "600px")};
  opacity: ${props => (props.isOpen ? "0" : "1")};

  .description {
    padding: 24px;
    border-radius: 0 0 2px 2px;
    .title {
      line-height: 32px;
      margin-bottom: 8px;
      font-size: 24px;
      font-weight: 300;
    }

    .projectTitle {
      font-size: 1rem;
      line-height: 110%;
      margin: 0.5rem 0 0.4rem 0;
      color: ${themeGet("colors.tertiaryDark")};
    }
  }
`
export const Details = styled.div`
  z-index: 2;
  padding: 24px;
  background-color: #fff;
  overflow: hidden;
  height: 500px;
  max-height: ${props => (props.isOpen ? "600px" : "0px")};
  transition: max-height 0.5s ease-out, opacity 0.25s ease-out;
  opacity: ${props => (props.isOpen ? "1" : "0")};

  .title {
    font-size: 24px;
    font-weight: 300;
  }
`
